import { retriable } from '~/apis/timeeApi/retriable';
import { aspidaClient } from '~/categories/admin/apis/utils/aspidaClient';
import {
  BusinessFactCheckEvidenceRejectReasonType,
  BusinessFactCheckEvidenceType,
  BusinessFactCheckRequest,
  BusinessFactCheckStatus,
  BusinessFactCheckDetail,
  BusinessFactCheckSummary,
} from '~/categories/admin/models/types/businessEvidence';
import { PaginationInfo } from '~/models/types/common';

export type IBusinessFactCheckApi = {
  fetchBusinessFactChecks(params: { type: BusinessFactCheckStatus; page: number }): Promise<{
    results: BusinessFactCheckSummary[];
    pagination: PaginationInfo;
  }>;
  fetchBusinessFactCheck(params: { businessFactCheckId: number }): Promise<BusinessFactCheckDetail>;
  fetchBusinessFactCheckRejectReasonTypes(): Promise<BusinessFactCheckEvidenceRejectReasonType[]>;
  fetchBusinessFactCheckEvidenceTypes(): Promise<BusinessFactCheckEvidenceType[]>;
  judgeBusinessFactCheck(params: BusinessFactCheckRequest): Promise<void>;
};

export const businessFactCheckApi: IBusinessFactCheckApi = {
  fetchBusinessFactChecks: (params) => {
    return retriable(
      async () =>
        await aspidaClient.api.v1.business_fact_checks.$get({
          query: { status: params.type, page: params.page },
        }),
    );
  },
  fetchBusinessFactCheck: (params) => {
    return retriable(
      async () =>
        await aspidaClient.api.v1.business_fact_checks
          ._business_fact_check_id(params.businessFactCheckId)
          .$get(),
    );
  },
  fetchBusinessFactCheckRejectReasonTypes: () => {
    return retriable(
      async () =>
        await aspidaClient.api.v1.master.business_fact_check.evidence.reject_reason_types.$get(),
    );
  },
  fetchBusinessFactCheckEvidenceTypes: () => {
    return retriable(
      async () => await aspidaClient.api.v1.master.business_fact_check.evidence.types.$get(),
    );
  },
  judgeBusinessFactCheck: (params) => {
    return aspidaClient.api.v1.business_fact_checks
      ._business_fact_check_id(params.businessFactCheckId)
      .$patch({
        body: {
          evidence: params.evidence,
        },
      });
  },
};
